import type { CyclePhasePain } from '@pelvia/shared/hooks/patient/usePainPatterns'

const PHASE_LABELS: Record<string, string> = {
  period: 'Period',
  follicular: 'Follicular',
  ovulation: 'Ovulation',
  luteal: 'Luteal',
}

/**
 * Average pain per menstrual-cycle phase as bars. Renders nothing until the
 * payload reports cycle data with at least one phase that has a pain average.
 */
export default function CyclePhaseCard({ cyclePhase }: { cyclePhase?: CyclePhasePain }) {
  if (!cyclePhase || !cyclePhase.has_data) return null
  if (!cyclePhase.phases.some((p) => p.avg_pain != null)) return null

  return (
    <section className="card">
      <h3 className="pp-card-title">Pain by cycle phase</h3>
      <p className="pp-card-desc">
        Average pain per cycle phase.
        {cyclePhase.message && (
          <span style={{ color: 'var(--text-muted)' }}> {cyclePhase.message}</span>
        )}
      </p>
      <div className="pp-phase-chart">
        {cyclePhase.phases.map((p) => {
          const h = p.avg_pain != null ? Math.max(2, (p.avg_pain / 10) * 120) : 2
          return (
            <div key={p.phase} className="pp-phase-col">
              <span className="pp-phase-val">{p.avg_pain ?? '—'}</span>
              <div
                className="pp-phase-bar"
                style={{
                  height: `${h}px`,
                  background: p.avg_pain != null ? p.color : 'var(--surface2)',
                }}
              />
              <div className="pp-phase-label">{PHASE_LABELS[p.phase] || p.phase}</div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
